import {Injectable} from '@angular/core';
import {Match} from '@shared/models/match';
import {TeamService} from './team.service';

import {APIService} from './api.service';
import {LeagueService} from './league.service';
import {HttpClient} from '@angular/common/http';
import {Lineup} from '@shared/models/lineup/lineup';

export interface MatchesReponse {
  events: Match[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class MatchService {

  private eventsRoute = 'events';

  private matches: Match[];

  private FORMATIONS =  {
    0: {type: '3-4-3', id: 0, position: ['TW', 'LV', 'ZIV', 'RV', 'LM', 'ZLM', 'ZRM', 'RM', 'LS', 'MS', 'RS']},
    1: {type: '3-2-2-1-2', id: 1, position: ['TW', 'LV', 'ZIV', 'RV', 'ZLDM', 'ZRDM', 'LM', 'RM', 'ZOM', 'LS', 'RS']},
    2: {type: '4-1-1-3-1', id: 2, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM', 'ZM', 'LM', 'ZOM', 'RM', 'MS']},
    3: {type: '4-1-2-3', id: 3, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM', 'LM', 'RM', 'LS', 'MS', 'RS']},
    4: {type: '4-1-4-1', id: 4, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM', 'LM', 'ZLM', 'ZRM', 'RM', 'MS']},
    5: {type: '4-2-3-1', id: 5, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZLDM', 'ZRDM', 'LM', 'ZOM', 'RM', 'MS']},
    6: {type: '4-3-1-2', id: 6, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM', 'ZM', 'RM', 'ZOM', 'LS', 'RS']},
    7: {type: '4-3-2-1', id: 7, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM', 'ZM', 'RM', 'ZOLM', 'ZORM', 'MS']},
    8: {type: '4-3-3', id: 8, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM', 'ZM', 'RM', 'LS', 'MS', 'RS']},
    9: {type: '4-4-2', id: 9, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM', 'ZLM', 'ZRM', 'RM', 'LS', 'RS']},
    10: {type: '4-4-2 Raute', id: 10, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM', 'LM', 'RM', 'ZOM', 'LS', 'RS']},
    11: {type: '5-3-2', id: 11, position: ['TW', 'LAV', 'LIV', 'ZIV', 'RIV', 'RAV', 'LM', 'ZM', 'RM', 'LS', 'RS']},
    12: {type: '5-4-1', id: 12, position: ['TW', 'LAV', 'LIV', 'ZIV', 'RIV', 'RAV', 'LM', 'ZLM', 'ZRM', 'RM', 'MS']},
    13: {type: '4-1-3-2', id: 13, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM', 'LM', 'ZM', 'RM', 'LS', 'RS']},
    14: {type: '5-2-1-2', id: 14, position: ['TW', 'LAV', 'LIV', 'ZIV', 'RIV', 'RAV', 'ZLDM', 'ZRDM', 'ZOM', 'LS', 'RS']},
    15: {type: '4-5-1', id: 15, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM', 'ZLM', 'ZM', 'ZRM', 'RM', 'MS']},
    16: {type: '3-5-1-1', id: 16, position: ['TW', 'LV', 'ZIV', 'RV', 'LM', 'ZLM', 'ZM', 'ZRM', 'RM', 'ZOM', 'MS']},
    17: {type: '3-4-2-1', id: 17, position: ['TW', 'LV', 'ZIV', 'RV', 'LM', 'ZLM', 'ZRM', 'RM', 'ZOLM', 'ZORM', 'MS']},
    18: {type: '4-2-2-2', id: 18, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZLDM', 'ZRDM', 'LM', 'RM', 'LS', 'RS']},
    19: {type: '3-5-2', id: 19, position: ['TW', 'LV', 'ZIV', 'RV', 'LM', 'ZLM', 'ZM', 'ZRM', 'RM', 'LS', 'RS']},
    20: {type: '3-1-4-2', id: 20, position: ['TW', 'LV', 'ZIV', 'RV', 'ZDM', 'LM', 'ZLM', 'ZRM', 'RM', 'LS', 'RS']},
    21: {type: '4-4-1-1', id: 21, position: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM', 'ZLM', 'ZRM', 'RM', 'ZOM', 'MS']},
    22: {type: '5-5-0', id: 22, position: ['TW', 'LAV', 'LIV', 'ZIV', 'RIV', 'RAV', 'LM', 'ZLM', 'ZM', 'ZRM', 'RM']},
    23: {type: '5-3-1-1', id: 23, position: ['TW', 'LAV', 'LIV', 'ZIV', 'RIV', 'RAV', 'LM', 'ZM', 'RM', 'ZOM', 'MS']},
};

  constructor(
    private http: HttpClient,
    private apiService: APIService,
    private leagueService: LeagueService,
    private teamService: TeamService,
  ) { }

  getMatches() {
    const matches = [];
    for (const m in this.matches) {
      if (this.matches.hasOwnProperty(m)) {
        matches.push(this.matches[m]);
        }
    }
    return matches;
  }

  getMatch(id: number): Match {
    return this.matches[id];
  }

  /***************************** HTTP GET FUNCTIONS *****************************/

  public async fetchMatch(id: string): Promise<Match> {
    const url = this.getMatchRoute(id);
    const response =  await this.http.get<Match>(url, this.apiService.getJsonOptions()).toPromise();
    if (response) {
      return this.resolveEvent(response);
    }
  }

  fetchMatchWithoutObjects(id: string): Promise<Match> {
    const url = this.getMatchRoute(id);
    return this.http.get<Match>(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => this.resolveEventWithoutObjects(response), err => this.handleError(err))
      .catch(this.handleError);
  }

  fetchTeamMatchesPaginated(teamid: string, order: string, skip: number, limit: number): Promise<MatchesReponse> {
    const url = this.getTeamMatchesPaginatedRoute(teamid, order, skip, limit);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => {
        return this.resolvePaginatedEventsWithoutObjects(response)
      })
      .catch(this.handleError);
  }

  fetchLeagueMatchesPaginated(leagueid: string, order: string, skip: number, limit: number): Promise<MatchesReponse> {
    const url = this.getLeagueMatchesPaginatedRoute(leagueid, order, skip, limit);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => {
        return this.resolvePaginatedEventsWithoutObjects(response)
      })
      .catch(this.handleError);
  }

  fetchLeagueSeasonMatchesPaginated(seasonId: string, order: string, skip: number, limit: number): Promise<MatchesReponse> {
    const url = this.getLeagueSeasonMatchesPaginatedRoute(seasonId, order, skip, limit);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => {
        return this.resolvePaginatedEventsWithoutObjects(response)
      })
      .catch(this.handleError);
  }

  fetchLeagueRoundMatches(leagueid: string, seasonId: string, round: number): Promise<MatchesReponse> {
    const url = this.getLeagueRoundMatchesRoute(leagueid, seasonId, round);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => {
        return this.resolvePaginatedEventsWithoutObjects(response)
      })
      .catch(this.handleError);
  }

  fetchMatchesOfUser(order: string, skip: number, limit: number): Promise<MatchesReponse> {
    const url = this.getMatchesOfUserRoute(order, skip, limit);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => {
        return this.resolvePaginatedEventsWithoutObjects(response)
      })
      .catch(this.handleError);
  }


  fetchMatchTimeline(matchID: string, teamID: string): Promise<any> {
    const url = this.getMatchTimelineRoute(matchID, teamID);
    return this.http.get(url, this.apiService.getJsonOptions()).toPromise();
  }

  fetchMatchOverview(matchID: string) {
    const url = this.getMatchOverviewRoute(matchID);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  async fetchMatchLineup(matchID: string, teamID: string): Promise<Lineup> {
    const url = this.getMatchLineupRoute(matchID, teamID);
    const response = await this.http.get(url, this.apiService.getJsonOptions()).toPromise();
    return this.resolveLineup(response);
  }

  fetchMatchLiveLineup(matchID: string, teamID: string) {
    const url = this.getMatchLiveLineupRoute(matchID, teamID);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => this.resolveLineup(response))
      .catch(this.handleError);
  }

  fetchMatchRanking(matchID: string, teamID: string) {
    const url = this.getMatchRankingInfoRoute(matchID, teamID);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  fetchRecentEventsWithVideos(): Promise<Match[]> {
    const url = this.getRecentMatchesWithVideoRoute();
    return this.http.get<Match[]>(url, this.apiService.getJsonOptions())
      .toPromise()
      .then((response: any) => this.resolveEvents(response.data))
      .catch(this.handleError);
  }

  /***************************** RESOLVE FUNCTIONS *****************************/

  resolveEvent(jsonEvent): Match {
    return this.resolveEventWithoutObjects(jsonEvent);
  }

  resolveEvents(jsonEvents) {
    const matches = [];

    const length = jsonEvents.length;
    for (let i = 0; i < length; i++) {
      matches.push(this.resolveEvent(jsonEvents[i]));
    }
    return matches;
  }

  resolvePaginatedEvents(jsonEvents): { events: Match[], total_count: number }  {
    const events = this.resolveEvents(jsonEvents.data);
    const totalCount = jsonEvents.total_count;
    return { events: events, total_count: totalCount };
  }

  resolveEventWithoutObjects(jsonEvent): Match {
    return new Match(jsonEvent);
  }

  resolveEventsWithoutObjects(jsonEvents): Match[] {
    const matches = [];

    const length = jsonEvents.length;
    for (let i = 0; i < length; i++) {
      matches.push(this.resolveEventWithoutObjects(jsonEvents[i]));
    }
    return matches;
  }

  resolvePaginatedEventsWithoutObjects(jsonEvents): { events: Match[], total_count: number }  {
    const events = this.resolveEventsWithoutObjects(jsonEvents.data);
    const totalCount = jsonEvents.total_count;
    return { events: events, total_count: totalCount };
  }

  resolveLineup(jsonLineup) {
    return new Lineup(jsonLineup.data);
  }

  /***************************** ROUTE DEFINITIONS *****************************/

  getMatchRoute(id: string) {
    return this.apiService.getBaseURL() + 'events/' + id;
  }

  getRecentMatchesWithVideoRoute() {
    return this.apiService.getBaseURL() + 'debug/events/withvideos/3';
  }

  getMatchTimelineRoute(matchID: string, teamID: string) {
    return this.getMatchRoute(matchID) + '/timeline/' + teamID;
  }

  getTeamMatchesPaginatedRoute(teamid: string, order: string, skip: number, limit: number) {
    return this.apiService.getBaseURL() + `v2/events/team/${teamid}/${order}/${skip}/${limit}/`;
  }

  getLeagueMatchesPaginatedRoute(id: string, order: string, skip: number, limit: number) {
    return this.apiService.getBaseURL() + `v2/events/league/${id}/${order}/${skip}/${limit}/`;
  }

  getLeagueSeasonMatchesPaginatedRoute(seasonId: string, order: string, skip: number, limit: number) {
    return this.apiService.getBaseURL() + `v2/events/season/${seasonId}/${order}/${skip}/${limit}/`;
  }

  getLeagueRoundMatchesRoute(id: string, season: string, round: number) {
    return this.apiService.getBaseURL() + `eventslist/league/${id}/season/${season}/round/${round}`;
  }

  getMatchesOfUserRoute(order: string, skip: number, limit: number) {
    return this.apiService.getBaseURL() + `v2/events/user/${order}/${skip}/${limit}/`;
  }


  getMatchOverviewRoute(matchID: string) {
    return this.apiService.getBaseURL() + 'activity/' + matchID + '/overview';
  }

  getMatchRankingInfoRoute(matchID: string, teamID: string) {
    return this.apiService.getBaseURL() + 'rankings/event/' + matchID + '/' + teamID + '/1/100';
  }

  getMatchLineupRoute(matchID: string, teamID: string) {
    return this.getMatchRoute(matchID) + '/lineup/' + teamID;
  }

  getMatchLiveLineupRoute(matchID: string, teamID: string) {
    return this.getMatchRoute(matchID) + '/live_lineup/' + teamID;
  }

  getFormations() {
    return this.FORMATIONS;
  }

  handleError(error) {
    console.log(error);
    return error;
  }


}
